module.exports = __webpack_public_path__ + "static/media/InventoryIcon.8a38dfa8.svg";